import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useI18n } from '../context/I18nContext';
import { APPS_DATA } from '../data/apps';
import { SeoHead } from '../components/common/SeoHead';
import { ContactBlock } from '../components/support/ContactBlock';

export const SupportIndexPage: React.FC = () => {
  const { t, resolveText } = useI18n();

  return (
    <div className="py-12 sm:py-16 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
      <SeoHead
        title="공식 고객지원 센터 | Support Hub"
        description="Kapitalletter 모바일 앱 공식 고객지원 센터입니다. 앱별 사용 안내, 문제 해결 가이드 및 문의 창구를 확인하세요."
        canonicalPath="/support"
      />

      {/* Header */}
      <div className="max-w-2xl">
        <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight">
          {t.support.title}
        </h1>
        <p className="mt-3 text-slate-600 text-base sm:text-lg">
          {t.support.subtitle}
        </p>
      </div>

      {/* App Specific Support Cards */}
      <section className="space-y-6">
        <h2 className="text-xl font-bold text-slate-900 tracking-tight">
          지원 대상 앱을 선택해 주세요
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {APPS_DATA.map((app) => (
            <Link
              key={app.id}
              to={`/support/${app.slug}`}
              className="bg-white border border-slate-200/90 rounded-2xl p-6 shadow-xs hover:border-primary-400 hover:shadow-sm transition-all duration-200 flex items-center justify-between group"
            >
              <div className="flex items-center gap-4">
                <img
                  src={app.iconUrl}
                  alt={app.name}
                  className="w-16 h-16 rounded-2xl object-cover border border-slate-100 shadow-xs shrink-0"
                />
                <div>
                  <h3 className="text-lg font-bold text-slate-900 group-hover:text-primary-700 transition-colors">
                    {app.name}
                  </h3>
                  <p className="text-xs text-slate-500 font-mono mt-0.5">
                    {app.currentVersion}
                  </p>
                  <p className="text-sm text-slate-600 line-clamp-1 mt-1">
                    {resolveText(app.tagline)}
                  </p>
                </div>
              </div>
              <div className="w-8 h-8 rounded-full bg-slate-100 group-hover:bg-primary-50 text-slate-400 group-hover:text-primary-700 flex items-center justify-center shrink-0 ml-4 transition-colors">
                <ArrowRight className="w-4 h-4" />
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* Central Contact Block */}
      <section className="pt-4">
        <ContactBlock />
      </section>
    </div>
  );
};
